"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organicReplicaApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function organicReplicaApiClient(networkClient) {
    return {
        getKeywordsAppRanks: async (query) => {
            return networkClient.getHttp(data_lib_1.ORGANIC_REPLICA_WEB_SERVICE, `/api/v2/organic-replica/keywords-ranks`, query);
        },
        getKeywordsSearchScoreRanks: async (query) => {
            return networkClient.getHttp(data_lib_1.ORGANIC_REPLICA_WEB_SERVICE, `/api/v2/organic-replica/keywords-search-score`, query);
        },
    };
}
exports.organicReplicaApiClient = organicReplicaApiClient;
